// Test Mode Wrapper Component
// Add this to: frontend/src/TestModeWrapper.js

import React from 'react';
import { AlertCircle, Code, Settings } from 'lucide-react';
import getEnvironmentConfig from './config';

const TestModeWrapper = ({ children }) => {
  const config = getEnvironmentConfig();
  
  // Show test mode screen if:
  // 1. Test mode is enabled AND
  // 2. We're not in development (so devs can always access)
  if (config.testMode && !config.isDevelopment) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Settings className="w-8 h-8 text-orange-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Site Under Development
          </h1>
          
          <p className="text-gray-600 mb-6">
            We're currently working on improvements to provide you with a better experience. 
            Please check back soon!
          </p>
          
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Code className="w-4 h-4 mr-2" />
              Environment: {config.environment}
            </div>
          </div>
          
          <div className="text-xs text-gray-400">
            For access, contact the development team
          </div>
        </div>
      </div>
    );
  }
  
  // Development mode indicator (only shown in dev)
  return (
    <>
      {config.isDevelopment && (
        <div className="fixed top-0 right-0 z-50 bg-blue-500 text-white px-3 py-1 text-xs font-medium">
          DEV MODE
        </div>
      )}
      
      {config.isRender && !config.testMode && (
        <div className="fixed top-0 right-0 z-50 bg-green-500 text-white px-3 py-1 text-xs font-medium">
          RENDER
        </div>
      )}
      
      {children}
    </>
  );
};

export default TestModeWrapper;